import { useMemo, useState } from "react";
import { ButtonTypes, ListData_ValueTypes, TableStyles_Types } from "../../../Definitions";
import { getCoreRowModel, useReactTable } from "@tanstack/react-table";
import { ReactiveTable } from "../../Tables/reactiveTableRenderer";
import { useTranslation } from "react-i18next";
import { useUser } from "../../../Services";
import { WorkerListModal } from "./workerListModal";
import { colors, fonts, glyphs } from "../../../Styles";
import { useColumnConstructor } from "../../Tables/_Tables/useColumnConstructor";
import NewButton from "../../BaseComponents/newButton";

export function WorkerList() {
    const { t } = useTranslation();
    const { workerList } = useUser();
    const [selectedWorkerId, setSelectedWorkerId] = useState<number | undefined>();

    const selectedWorker = useMemo(
        () => workerList?.find(worker => worker.user_id === selectedWorkerId),
        [workerList, selectedWorkerId]
    );

    const accessorData = useMemo(() =>
        [
            { headerValue: t("user.userName", { defaultValue: "username" }), accessor: "action", type: ListData_ValueTypes.String }
        ], 
        [t]
    );

    const columns = useColumnConstructor({
        accessorData: [...accessorData],
        tableStyle: TableStyles_Types.lightTable,
        canEdit: false,
    });

    const tableData = useMemo(() => {
        return workerList?.map((e) => ({
            id: e.user_id,
            action:
                <NewButton
                    key={e.user_id}
                    content={e.username}
                    buttonType={ButtonTypes.textButton}
                    startEnhancer={ glyphs.ArrowSmooth({fillColor: colors.greyDarkSecondary})}
                    onClick={() => setSelectedWorkerId(e.user_id)}
                    overrides={{
                        startEnhancerStyles: { margin: "0px 0px 2px 0px" }
                    }}
                />
        })) ?? [];
    }, [workerList]);

    const table = useReactTable({
        columns,
        data: tableData,
        getCoreRowModel: getCoreRowModel(),
        getRowId: (row) => String(row.id),
    });

    function closeModal() {
        setSelectedWorkerId(undefined);
    }

    return (
        <div style={{ height: "11vh" }}>
            <ReactiveTable
                table={table}
                tableType={TableStyles_Types.lightTable}
                emptyText={"No users found"}
                renderFooter={false}
            />
            {selectedWorker && <WorkerListModal worker={selectedWorker} closeModal={closeModal} />}
        </div>
    );
}